import { SubmissionList } from "../../components/datatable/SubmissionList"
import { Navbar } from "../../components/navbar/Navbar"
import { Sidebar } from "../../components/sidebar/Sidebar"
import "./studentHome.scss"

export const StudentHome = () => {
  return (
    <div className="list">
    <Sidebar/>
    <div className="listContainer">
        <Navbar/>
        <SubmissionList/>
            
    </div>
    </div>
  )
}


export default StudentHome
